import { Slot } from '@radix-ui/react-slot'
import type { VariantProps } from 'class-variance-authority'
import { type ButtonHTMLAttributes, forwardRef } from 'react'
import { cn } from '#src/cn.ts'
import { buttonVariants } from '#src/components/Button/buttonVariants.ts'

export interface ButtonProps
  extends
    Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'color'>,
    VariantProps<typeof buttonVariants> {
  asChild?: boolean
}

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(
  (
    {
      className,
      variant,
      size,
      color,
      loading,
      disabled,
      selected,
      type = 'button',
      asChild = false,
      ...delegated
    },
    ref
  ) => {
    const Comp = asChild ? Slot : 'button'
    return (
      <Comp
        className={cn(
          buttonVariants({ variant, size, color, loading, selected, className })
        )}
        disabled={loading ? true : disabled}
        ref={ref}
        type={type}
        {...delegated}
      />
    )
  }
)
Button.displayName = 'Button'
